import React, { type FC } from 'react'

import type { PartialReadonlyRecord } from '../../../../utils'

import { Capability, type CybusDetailedEndpoint, StatusType, Translation } from '../../../../domain'

import { DeleteIcon, EnableIcon, PauseIcon } from '../../common'
import { DetailsActionButton } from '../../Details'
import { useAppUsecases } from '../../State'

const disableButtonLabels: PartialReadonlyRecord<StatusType, Translation> = {
    [StatusType.ENABLED]: Translation.DISABLE,
    [StatusType.ENABLING]: Translation.ENABLING,
}

export const HeaderActions: FC<{ resource: CybusDetailedEndpoint }> = ({ resource: { id, status } }) => {
    const { bulkDeleteEndpointsUsecase, bulkEnableEndpointsUsecase, bulkDisableEndpointsUsecase } = useAppUsecases()

    return (
        <>
            <DetailsActionButton
                data-testid="endpoint-action-button"
                disabled={status !== StatusType.ENABLED && status !== StatusType.DISABLED}
                text={disableButtonLabels[status] || Translation.ENABLE}
                capabilities={[Capability.ENDPOINTS_MANAGE]}
                onClick={status === StatusType.ENABLED
                    ? () => bulkDisableEndpointsUsecase.selectEndpoints([id])
                    : () => bulkEnableEndpointsUsecase.selectEndpoints([id])}
                startIcon={status === StatusType.ENABLED ? <PauseIcon /> : <EnableIcon />}
                showText
            />

            <DetailsActionButton
                data-testid="delete-endpoint-button"
                text={Translation.DELETE}
                capabilities={[Capability.ENDPOINTS_MANAGE]}
                onClick={() => bulkDeleteEndpointsUsecase.selectEndpoints([id])}
                startIcon={<DeleteIcon />}
                variant="dangerOutline"
            />
        </>
    )
}
